<template>

	<div>

		<div :class="['tabContentSection', { 'is-disabled': isSaving}]">

			<div class="tabContentSectionBlock createdBy">
				<small>angelegt am {{ formatDate2(content.created) }} von {{ content.createdBy.username }}</small>
			</div>

			<div class="tabContentSectionBlock" :key="defaultImage">

				<div ref="teaserImage" class="teaserImage lazy-img-fadein" v-lazy:background-image="defaultImage" @click="imagePoolOpen">

					<template v-if="defaultImage && ['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1">
						<pop-confirm class="icon is-small imageRemove" content="Möchten Sie dieses Bild wirklich entfernen?" cancel-text="nein" ok-text="ja" :on-ok="function() { imageRemove() }">
							<i class="icon-ak-entfernen" title="Bild entfernen"></i>
						</pop-confirm>
					</template>

				</div>

			</div>

			<div class="tabContentSectionBlock">

				<div class="columns is-multiline maxWidth is-gapless">

					<!-- TITLE -->
					<div class="column is-6">
						<form-input label="CPC-TITLE_INTERN" inputType="text" v-model="content.title" :is-horizontal="false" :isReadOnly="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) == -1"></form-input>
					</div>

					<!-- CONTENT TYPE -->
					<div class="column is-6">
						<form-input label="CPC-TYPE" inputType="select" :selectAllowEmpty="false" :selectOptions="articleTypes" v-model="content.type" :is-horizontal="false" :selectIsDisabled="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) == -1"></form-input>
					</div>

					<!-- CATEGORIES -->
					<div class="column is-6">
						<div class="control">
							<div class="control-label">
								<label-name labelKey="CPC-CATEGORIES_INTERN"></label-name>
							</div>
							<div class="control">
								<multiselect
									v-model="contentCategories"
									:options="categories"
									label="name"
									deselect-label="Klick um abzuwählen"
	                selectLabel="Klick um auszuwählen"
									selectedLabel="ausgewählt"
									:placeholder="$t('SELECT_BOX-CPC-CATEGORY-PLEASE_SELECT')"
									:multiple="true"
									:close-on-select="false"
									:clear-on-select="false"
									:hide-selected="true"
									:preserve-search="false"
									:disabled="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) == -1"
									@input="onSelectCategoryChange"
									track-by="id"
									class="singleSelect">
								</multiselect>
							</div>
						</div>
					</div>

					<!-- TOPICS -->
					<div class="column is-6">
						<div class="control">
							<div class="control-label">
								<label-name labelKey="CPC-TOPICS"></label-name>
							</div>
							<div class="control">
								<multiselect
									v-model="contentTopics"
									:options="topics"
									label="name"
									deselect-label="Klick um abzuwählen"
	                selectLabel="Klick um auszuwählen"
									selectedLabel="ausgewählt"
									:placeholder="$t('SELECT_BOX-CPC-TOPIC-PLEASE_SELECT')"
									:multiple="true"
									:close-on-select="false"
									:clear-on-select="false"
									:hide-selected="true"
									:preserve-search="false"
									:disabled="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) == -1"
									@input="onSelectTopicChange"
									track-by="id"
									class="singleSelect">
								</multiselect>
							</div>
						</div>
					</div>

				</div>
			</div>

			<div class="tabContentSectionBlock">

				<div class="tabContentSectionBlock-headline">Versionen</div>

				<div class="contentElements columns is-multiline is-gapless maxWidth">

					<template v-for="(variant, index) in articleVariantTypes" v-if="['HERBA_IMPULSE_PRINT', 'HERBA_IMPULSE_ONLINE', 'INTRANET', 'COOPERATE'].indexOf(variant.name) > -1">


						<div v-if="content.variants.filter(e => e.type.name === variant.name).length > 0" :class="['contentElement column is-6', variantGetStatus(variant), { 'is-disabled': !variantIsActive(variant) }]" @click="setActiveTab(variant.name)" :title="'gehe zu ' + $t('CPC-'+variant.name)">

							<div class="type"><lang :labelKey="'CPC-'+variant.name"></lang></div>

							<div class="status">
								<div>
									<span><small>Status</small></span><br />
									<span>{{ variantGetStatus(variant, true) }}</span>
								</div>
							</div>

							<div class="lastUpdate">
								<div>
									<small>Letzte Änderung</small><br />
									<span>{{ getLastUpdated(variant) }}</span>
								</div>
							</div>

						</div>

						<div v-else :class="['contentElement column is-6 UNTOUCHED',  { 'is-disabled': !variantIsActive(variant) }]" @click.stop="createVariant(variant)" :title="'neu anlegen: ' + $t('CPC-'+variant.name)">

							<div class="inner">

								<template v-if="variant.isCreating">
									<loading-indicator-pulse class="small"></loading-indicator-pulse>
								</template>

								<template v-else>
									<lang :labelKey="'CPC-'+variant.name"></lang>
									<span class="icon is-small"><i class="fa icon-ak-hinzufuegen"></i></span>
								</template>

							</div>
						</div>

					</template>

				</div>

			</div>

			<div class="tabContentSectionBlock">

				<div class="tabContentSectionBlock-headline">Teaser</div>

				<div class="contentElements columns is-multiline is-gapless maxWidth">

					<template v-for="(variant, index) in articleVariantTypes" v-if="['FACEBOOK', 'NEWSLETTER', 'TEASER_INTERNAL'].indexOf(variant.name) > -1">

						<div v-if="content.variants.filter(e => e.type.name === variant.name).length > 0" :class="['contentElement column is-6', variantGetStatus(variant), { 'is-disabled': !variantIsActive(variant) }]" @click="setActiveTab(variant.name)" :title="'gehe zu ' + $t('CPC-'+variant.name)">

							<div class="type"><lang :labelKey="'CPC-'+variant.name"></lang></div>

							<div class="status">
								<div>
									<span><small>Status</small></span><br />
									<span>{{ variantGetStatus(variant, true) }}</span>
								</div>
							</div>

							<div class="lastUpdate">
								<div>
									<small>Letzte Änderung</small><br />
									<span>{{ getLastUpdated(variant) }}</span>
								</div>
							</div>

						</div>

						<div v-else :class="['contentElement column is-6 UNTOUCHED', { 'is-disabled': !variantIsActive(variant) }]" @click.stop="createVariant(variant)" :title="'neu anlegen: ' + $t('CPC-'+variant.name)">
							<div class="inner">
								<lang :labelKey="'CPC-'+variant.name"></lang>
								<span class="icon is-small"><i class="fa icon-ak-hinzufuegen"></i></span>
							</div>
						</div>

					</template>

				</div>

				<!--
				<template v-if="['matthias'].indexOf(activeUser.username) > -1">

					<a class="button is-light is-small" @click="showRawData=!showRawData">zeige raw data</a>
					<div v-if="showRawData">
						<pre>{{ content }}</pre>
					</div>

				</template>
				-->

			</div>

			<div class="tabButtons" v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1">
				<router-link :to="{ name: 'complatContentPoolContentChangeLog', params: { 'contentID': content.id }}" :class="{'is-disabled': !content.id }">
					<custom-button name="CP-BTN-CHANGELOG" type="dark" size="small" icon="icon-ak-history" :class="{'is-disabled': !activeUser.isAdminRole && !content.id }"></custom-button>
				</router-link>
			</div>

		</div>

		<!-- CALENDAR -->
		<div class="tabContentSection calendar" v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1">
			<div class="title is-5">Kalender</div>
			<calendar :articleId="content.id" v-if="content.id"></calendar>
		</div>

		<!-- COMMENTS -->
		<div class="tabContentSection comments">
			<comments v-if="content.id" :threadID.sync="content.thread" :api="'article/'+content.id"></comments>
		</div>

		<image-pool :articleId="content.id" :assets="content.assets" :show="showImagePool" @close="showImagePool=false" @selectImage="selectImagePoolImage" :singleImage="true"></image-pool>

	</div>

</template>


<script>
import comments from '../../utils/incl-comments';
import imagePool from './incl-imagePool';
import calendar from '../calendar/incl-complatCalendar';


export default {

  name: 'contentPoolContentOverview',

	props: {

		content: {
			type: Object,
			default: function() { return {} }
		},
		categories: {
			type: Array,
			default: function() { return [] }
		},
		topics: {
			type: Array,
			default: function() { return [] }
		},
		contentCategories: {
			type: Array,
			default: function() { return [] }
		},
		contentTopics: {
			type: Array,
			default: function() { return [] }
		},
		isSaving: {
			type: Boolean,
			default: false
		}
	},

	components: {
		comments,
		imagePool,
		calendar
	},

	computed: {

		articleTypes() {
			return this.$store.getters.getTermsByTaxonomy('ARTICLE_TYPES');
		},

		articleVariantTypes() {
			return this.$store.getters.getTermsByTaxonomy('ARTICLE_VARIANT_TYPES');
		},

		articleVariantStatus() {
			return this.$store.getters.getTermsByTaxonomy('ARTICLE_VARIANT_STATUS');
		},

		defaultImage() {

			for(let k in this.content.assets) {
				if(this.content.assets[k].isDefault == true) {
					return this.$config.assets + this.content.assets[k].asset.path + '/' + this.content.assets[k].asset.filename;
				}
			}

		}
	},

    data() {

      return {
        isLoading: false,
				showRawData: false,
				showImagePool: false,
			}

	},

	created() {


	},

	methods: {


		onSelectTopicChange(val, id) {

			this.$emit('setContentTopics', this.contentTopics);

		},

		onSelectCategoryChange(val, id) {

			this.$emit('setContentCategories', this.contentCategories);

		},

		setActiveTab(variantName) {

			this.$emit('setActiveTab', variantName);

		},

		createVariant(variant) {

			if(['Administrator', 'Administrator JTM', 'Herba Chefredaktion', 'Agentur Chefredaktion', 'Autor'].indexOf(this.activeUser.userRole.name) == -1) {
				this.$notify.open({content: 'Sie sind nicht berechtigt, diese Funktion auszuführen.', type: 'warning'})
				return;
			}

			// a global title must be set
			if(this.content.title == "") {
				this.$notify.open( {content: 'Bitte geben Sie mindestens einen internen Titel an!', type: 'warning'});
				return false;
			}

			this.$emit('createVariant', variant);

		},

		/*
		isVariantActive(variantName) {

			return this.content.variants.find(function (obj) {
				if(obj.type) {
					return obj.type.name == variantName && obj.createdBy != "";
				}
			});

		},
		*/



		variantGetStatus(variant, translate=false) {

			var obj = this.content.variants.find((obj) => obj.type && obj.type != null ? obj.type.name == variant.name : false);

			if(translate == true) {
				return obj && obj.status != null ? this.$t('CPC-VARIANT-STATUS-'+obj.status.name) : "DEFAULT";
			} else {
				return obj.status.name;
			}

		},

		variantIsActive(variant) {

			if(['Administrator', 'Administrator JTM', 'Herba Chefredaktion', 'Herba Leitung'].indexOf(this.activeUser.userRole.name) > -1) {
				return true;
			}

			let v = this.content.variants.find( obj => { return obj.type && obj.type != null ? obj.type.name == variant.name : false; });

			if(typeof v == 'undefined' || v.assignee == null) {
				return false;
			}

			return v.assignee.id == this.activeUser.id;

		},


		getLastUpdated(variant) {

			var obj = this.content.variants.find(function (obj) {
				return obj.type && obj.type != null ? obj.type.name == variant.name : false;
			});

			return obj.updated != null ? this.formatDate2(obj.updated, true) : "--";

		},

		imagePoolOpen() {

			if(['Administrator', 'Administrator JTM', 'Herba Chefredaktion', 'Agentur Chefredaktion', 'Autor'].indexOf(this.activeUser.userRole.name) == -1) {
				this.$notify.open({ content: 'Sie sind nicht berechtigt dieses Bild zu ändern', type: 'warning' } );
				return;
			}

			this.showImagePool = true;

		},

		selectImagePoolImage(images) {

			let image = images[0], found = false, self = this;

			/*
			// loop through all assets and set the selected image as default
			for(var i in this.content.assets) {

				this.content.assets[i].isDefault = false;

				if(this.content.assets[i].id == image.id) {
					found = true;
					this.content.assets[i].isDefault = true;
				}

			}
			*/

			// loop through all assets and set the selected image as default
			for(let i in this.content.assets) {

				this.content.assets[i].isDefault = false;

				if(this.content.assets[i].asset.id == image.asset.id) {
					found = true;
					this.content.assets[i].isDefault = true;
				}

			}

			// if asset was not found, we create a new one ...
			if(!found) {
				image.isDefault = true;
				this.content.assets.push(image);
			}

			// todo: loop through all variants and set the teaser- and headerimage to the selected one (?)


			this.showImagePool = false;

		},

		imageRemove() {

			for(let i in this.content.assets) {
				this.content.assets[i].isDefault = false;
			}

		}
	}

}

</script>


<style scoped>


.inner .v-spinner {
	height: auto !important;
}
.teaserImage {
	position: relative;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: contain;
	background-color: #F5F5F5;
	border: 1px solid #ddd;
	border-radius: 3px;
	height: 150px;
	width: 250px !important;
	cursor: pointer;
}
.teaserImage[lazy=loading] {
    background-size: 20% !important;
    margin: 0;
}
.teaserImage[lazy=error] {
    background-image: none !important;
}
.teaserImage .imageRemove {
	position: absolute;
	top: 0;
	right: 0;
	width: 18px;
	height: 18px;
	background: #f5f5f5;
	font-size: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	visibility: hidden;
}
.teaserImage:hover .imageRemove {
	visibility: visible;
}


.columns {
	justify-content: space-between;
}
.columns > .column.is-6 {
	width: 49%;
}


.tabContentSection.calendar {
	margin: 25px 0;
}
.tabContentSection.calendar .title.is-5 {
    margin: 0 0 25px 0;
    text-transform: uppercase;
}
.tabContentSection.calendar >>> .box {
	padding: 0 !important;
	border-radius: 0 !important;
	background-color: transparent !important;
}
.tabContentSectionBlock-headline {
	font-size: 12px;
	margin-bottom: 25px;
	padding: 0;
}
.contentElements .contentElement {
	margin-bottom: 10px;
	min-height: 65px;
	background-color: #F5F7F9;
	border-radius: 5px;
	display: flex;
	flex-wrap: nowrap;
	justify-content: center;
	border-left: 10px solid transparent;
	cursor: pointer;
	transition: all .3s ease;
	font-size: 12px;
}
.contentElements .contentElement:hover {
	background: #E5E5E5;
}

.is-disabled {
	pointer-events: none;
	-webkit-filter: grayscale(1);
	filter: grayscale(1);
	opacity: 0.5;
}
.contentElements .contentElement.is-disabled {
	/*background-color: #f5f7f9a1;*/
	-webkit-filter: grayscale(1);
	filter: grayscale(1);
	opacity: 0.5;
}
.contentElements .contentElement.is-disabled .inner {
	color: #ccc !important;
}

.contentElements .contentElement.UNTOUCHED.is-disabled .inner .icon {
	display: none;
}

.contentElements .contentElement.UNTOUCHED.is-disabled .inner span:first-child::after {
	display: block;
	content: "nicht angelegt";
	text-transform: none;
	font-style: italic;
	text-align: center;
	color: #888;
	font-size: 10px;
}


.contentElements .contentElement.NEW {
	border-left-color: #CDCDD2;
}
.contentElements .contentElement.DRAFT {
	border-left-color: #76d8db;
}
.contentElements .contentElement.PROOF_READ {
	border-left-color: #f1ba84;
}
.contentElements .contentElement.APPROVAL {
	border-left-color: #84a6d4;
}
.contentElements .contentElement.APPROVED {
	border-left-color: #e996ca;
}
.contentElements .contentElement.LAYOUT {
	border-left-color:  #ffec7c;
}
.contentElements .contentElement.READY {
	border-left-color: #bfe29e;
}




/* variant not created yet */
.contentElements .contentElement.UNTOUCHED {
	flex-direction: row;
	justify-content: center;
	align-items: center;
	color: #45a7d6 !important;
}
.contentElements .contentElement.UNTOUCHED .inner {
	line-height: 18px;
}

.contentElements .contentElement.UNTOUCHED span:not(.icon) {
	border: none;
	text-transform: uppercase;
	padding: 0;
}
.contentElements .contentElement.UNTOUCHED span.icon {
	margin-left: 5px
}


.contentElement:not(.UNTOUCHED) > div {
	height: 100%;
	width: 100%;
	border-right: 1px solid #ddd;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 2%;
}
.contentElement > div.type {
	justify-content: flex-start;
	text-transform: uppercase;
	min-width: 100px;
	max-width: 120px;
	overflow: hidden;
}
.contentElement > div.status {
	justify-content: flex-start;
}
.contentElement > div.lastUpdate {
	justify-content: flex-start;
	max-width: 180px;
	border-right: none;
}




.contentElement > div small {
	font-size: .7rem !important;
	color: #aaa;
}

.maxWidth {
	max-width: 860px;
}
</style>
